module.exports = __webpack_public_path__ + "img/kunzhou.png";